'use client'

import RouteErrorBoundary from '@/components/common/RouteErrorBoundary'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      title="Error loading Vaults page data"
      description="Something went wrong while loading Vaults page data. Please try again."
      homeRoute="/"
      route="/vaults"
    />
  )
}
